import { ReactElement } from "react";
import Markdown, { Options } from "react-markdown";
import s from "./MarkdownRenderer.module.css";

type MarkdownRendererProps = Pick<Options, "children"> & {
  CustomVideoComponent?: (src?: string) => ReactElement;
};

export default function MarkdownRenderer({
  children,
  CustomVideoComponent,
}: MarkdownRendererProps) {
  return (
    <div className={s.MarkdownContainer}>
      <Markdown
        components={{
          img({ src, alt }) {
            if (!src) return null;
            const format = extractFileFormat(src);
            if (format && isVideoFormat(format)) {
              const Video = CustomVideoComponent
                ? ({ src }: { src?: string }) => CustomVideoComponent(src)
                : DefaultVideoComponent;
              return <Video src={src} />;
            }
            return <img src={src} alt={alt} />;
          },
        }}
      >
        {children}
      </Markdown>
    </div>
  );
}

const DefaultVideoComponent = ({ src }: { src?: string }) => (
  <video src={src} controls />
);

const videoFormats = [".mp4"] as const;

type VideoFormat = (typeof videoFormats)[number];

const isVideoFormat = (format: string): format is VideoFormat => {
  return videoFormats.includes(format as VideoFormat);
};

const extractFileFormat = (url: string): string | null => {
  // Use regex to extract the file extension
  const match = url.match(/\.([a-zA-Z0-9]+)(\?.*|#.*|$)/);

  return match ? `.${match[1].toLowerCase()}` : null;
};
